(function(){
	'Use Strict';
	angular.module('app.contactus').controller('stJudesCtrl',['$scope', function($scope){

		$scope.mainCarousel = ['https://www.fischerhomes.com/cf-imgs/heroes/13/hd/2020_st-jude_Keaton-AF-Low-Stone-Siding-FL-elev.jpg'];

		$scope.youtubeVideo = 'https://www.youtube.com/watch?v=6hBHV2I7ikU';

	}]);
}());